import { Component } from '@angular/core';
import { FeedbackPlatformCommitteeSelectionItemEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Committee Selection Items') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformcommitteeselectionitem-form',
    templateUrl: './feedbackplatformcommitteeselectionitem.form.component.html'
})
export class FeedbackPlatformCommitteeSelectionItemFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformCommitteeSelectionItemEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

